"use client";

import { useStoryblokState, StoryblokComponent } from "@storyblok/react";

const EXCLUDED_BLOCKS = ["hero"];

export default function HomePage({ story }: { story: any }) {
  const liveStory = useStoryblokState(story);

  if (!liveStory?.content) {
    return <div>Error: Story content missing</div>;
  }

  const pageContent = liveStory.content as any;

  return (
    <>
      {Array.isArray(pageContent.body) &&
        pageContent.body
          .filter((blok: any) => !EXCLUDED_BLOCKS.includes(blok.component))
          .map((blok: any) => (
            <StoryblokComponent blok={blok} key={blok._uid} />
          ))}

      {/*{Array.isArray(pageContent.quote_form) &&*/}
      {/*  pageContent.quote_form.map((quoteBlok: any) => (*/}
      {/*    <StoryblokComponent blok={quoteBlok} key={quoteBlok._uid} />*/}
      {/*  ))}*/}

      {/*{Array.isArray(pageContent.qualifications) &&*/}
      {/*  pageContent.qualifications.map((qualification: any, index: number) =>*/}
      {/*    typeof qualification === "string" ? (*/}
      {/*      <div key={index}>Qualification ID: {qualification}</div>*/}
      {/*    ) : (*/}
      {/*      <StoryblokComponent blok={qualification} key={qualification._uid} />*/}
      {/*    )*/}
      {/*  )}*/}

      {/*{Array.isArray(pageContent.top_brands) &&*/}
      {/*  pageContent.top_brands.map((brand: any, index: number) =>*/}
      {/*    typeof brand === "string" ? (*/}
      {/*      <div key={index}>Top Brand ID: {brand}</div>*/}
      {/*    ) : (*/}
      {/*      <StoryblokComponent blok={brand} key={brand._uid} />*/}
      {/*    )*/}
      {/*  )}*/}
    </>
  );
}